import { itemDef } from "./items.ts";

/**
 * Construção em grade (doc 03; doc 07, I2): 2 m na horizontal, 1 m na vertical, giro de 90°, vão
 * máximo de 4 células sem apoio vertical. Hipóteses de playtest, centralizadas aqui.
 */
export const BUILD = {
  cell: 2,
  level: 1,
  /** Alcance para construir e desmontar (m). */
  reach: 8,
  /** Nenhuma peça a mais de 4 células horizontais de um apoio vertical. */
  maxSpan: 4,
  maxPieces: 400,
  /** Cascata: atraso entre um salto e o próximo (ms). */
  cascadeHopMs: 100,
  wallHeight: 2,
  wallThickness: 0.2,
  floorThickness: 0.2,
  /** O Alicerce desce até 2 m em declive. */
  foundationDepth: 2,
  /** Vão da porta (no meio da parede de 2 m) e alcance para abrir. */
  doorWidth: 1,
  doorReach: 3,
  /** Estacada: dano por toque em assombração, intervalo e desgaste por toque. */
  stakeDamage: 6,
  stakeInterval: 1,
  stakeWear: 5,
  /** Assombração roendo construção: fração do dano do ataque. */
  gnawFactor: 0.5,
} as const;

export type PieceKind = "alicerce" | "piso" | "parede" | "porta" | "rampa" | "telhado" | "estacada";
/** Centro da célula (pisos, rampas, telhados, alicerces) ou borda (paredes, portas, estacadas). */
export type PieceSlot = "centro" | "borda";

export interface PieceSpec {
  item: string;
  kind: PieceKind;
  slot: PieceSlot;
  hp: number;
}

const KINDS: Record<string, PieceKind> = {
  "alicerce-pedra": "alicerce",
  "piso-tabuas": "piso",
  "parede-tabuas": "parede",
  "parede-taipa": "parede",
  "parede-porta": "porta",
  "rampa-tabuas": "rampa",
  "telhado-palha": "telhado",
  estacada: "estacada",
};

/** Peça de construção do item (catálogo do doc 03), ou `undefined`. */
export function pieceOf(itemId: string | undefined): PieceSpec | undefined {
  const kind = itemId ? KINDS[itemId] : undefined;
  const def = itemId ? itemDef(itemId) : undefined;
  if (!kind || !def?.placeable) return undefined;
  return { item: def.id, kind, slot: def.placeable.edge ? "borda" : "centro", hp: def.placeable.hp };
}

export const PIECE_ITEMS: readonly string[] = Object.keys(KINDS);
